<div class="flex items-center justify-center lg:p-6">
    <!-- Author: FormBold Team -->
    <div class="mx-auto w-full lg:max-w-[550px] bg-white">

        <h2 class="lg:mt-6 xs:mt-1 py-4 text-center text-3xl leading-9 font-extrabold text-[#7B68EE]">
            Personal Information  
        </h2>
        <form (ngSubmit)="onSubmit()" #userForm="ngForm">
          <div class="flex flex-wrap">
            <div class="w-full">
              <div class="mb-5 mx-4">
                <label for="lName" class="mb-3 block text-base font-medium text-[#07074D]">
                  Full Name
                </label>
                <input type="text" name="lName" id="lName" placeholder="NA" [disabled]="!isEditMode" [(ngModel)]="userData.name"
                [ngClass]="{'border-purple-700': isEditMode, 'border-[#e0e0e0]': !isEditMode}"
                class="w-full rounded-md border bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:shadow-md"/>
              </div>
            </div>
          </div>
          <div class="mb-5 mx-4">
            <label for="email" class="mb-3 block text-base font-medium text-[#07074D]">
              Email Address
            </label>
            <input type="email" name="email" id="email" placeholder="NA" [disabled]="!isEditMode" [(ngModel)]="userData.email"
            [ngClass]="{'border-purple-700': isEditMode, 'border-[#e0e0e0]': !isEditMode}"
            class="w-full rounded-md border bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:shadow-md" />
          </div>
          <div class="mb-5 mx-4">
            <label for="number" class="mb-3 block text-base font-medium text-[#07074D]">
              Mobile number
            </label>
            <input type="number" name="number" id="number" placeholder="NA" [disabled]="!isEditMode" [(ngModel)]="userData.mobile"
            [ngClass]="{'border-purple-700': isEditMode, 'border-[#e0e0e0]': !isEditMode}"
            class="w-full rounded-md border bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:shadow-md" />
          </div>
           <!-- <div class="mb-5 mx-4">
            <label for="lName" class="mb-3 block text-base font-medium text-[#07074D]">
              Address
            </label>
            <input type="text" name="address" id="address" placeholder="NA" [disabled]="!isEditMode" [(ngModel)]="userData.address"
            [ngClass]="{'border-purple-700': isEditMode, 'border-[#e0e0e0]': !isEditMode}"
            class="w-full rounded-md border bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:shadow-md" />
          </div>
          <div class="mb-5 mx-4">
            <label for="lName" class="mb-3 block text-base font-medium text-[#07074D]">
              city
            </label>
            <input type="text" name="city" id="city" placeholder="NA" [disabled]="!isEditMode" [(ngModel)]="userData.city"
            [ngClass]="{'border-purple-700': isEditMode, 'border-[#e0e0e0]': !isEditMode}"
            class="w-full rounded-md border bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:shadow-md"/>
          </div>
          <div class="mb-5 mx-4">
            <label for="lName" class="mb-3 block text-base font-medium text-[#07074D]">
              pincode
            </label>
            <input type="text" name="pincode" id="pincode" placeholder="NA" [disabled]="!isEditMode" [(ngModel)]="userData.pincode"
            [ngClass]="{'border-purple-700': isEditMode, 'border-[#e0e0e0]': !isEditMode}"
            class="w-full rounded-md border bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:shadow-md" />
          </div>
          
          <div class="mb-5 mx-4">
            <label for="lName" class="mb-3 block text-base font-medium text-[#07074D]">
              country
            </label>
            <select type="text" name="country" id="country" placeholder="NA" [disabled]="!isEditMode" [(ngModel)]="userData.country" (change)="countryselected($event)"
              [ngClass]="{'border-purple-700': isEditMode, 'border-[#e0e0e0]': !isEditMode}"
  class="w-full rounded-md border bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:shadow-md">
  <option class="">Select Country</option>
  <option value="India" >India</option>
 
</select>
  
          </div>
          <div class="mb-5 mx-4">
            <label for="lName" class="mb-3 block text-base font-medium text-[#07074D]">
              state
            </label>
            <select type="text" name="state" id="state" placeholder="" [disabled]="!isEditMode" [(ngModel)]="userData.state"
            [ngClass]="{'border-purple-700': isEditMode, 'border-[#e0e0e0]': !isEditMode}" 
            class="w-full rounded-md border bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:shadow-md" >
            <option >Select State</option>
  
            
              <option *ngFor="let state of countries?.states" [value]="state.name" selected>{{state.name}}</option>
            </select>
          </div> -->
          <div>
            <!-- Submit Button: only visible when in edit mode -->
            <button type="submit" class="btncolor hover:shadow-form rounded-md py-3 px-8 text-center text-base font-semibold text-white outline-none"
              [disabled]="!isEditMode" *ngIf="isEditMode">
              Submit
            </button>
            <!-- Edit/Cancel Button: toggles edit mode -->
            <button type="button" (click)="toggleEditMode()" class="hover:shadow-form ml-5 rounded-md bg-white py-3 px-8 text-center text-base cursor-pointer font-semibold text-black border-2 border-purple-700">
              {{ isEditMode ? 'Cancel' : 'Edit' }}
            </button>
          </div>
        </form>
        
    </div>
</div>
